import React from 'react';
import Plotly from 'plotly.js-dist-min'; // This provides the Plotly namespace for types
import createPlotlyComponent from 'react-plotly.js/factory';

// 1. Define an interface for your chartData structure
interface ChartDataType {
  data?: Plotly.Data[]; // Plotly.Data[] for array of traces
  layout?: Partial<Plotly.Layout>; // Partial<Plotly.Layout> for layout properties
}

// 2. Define an interface for the component's props
interface DynamicPlotlyChartProps {
  chartData: ChartDataType;
  width: string | number; // Width can be a string (e.g., "500") or number
  height: string | number; // Height can be a string (e.g., "300") or number
}

// Create the Plotly component using the factory
const Plot = createPlotlyComponent(Plotly);

// 3. Apply the props interface to your functional component
const DynamicPlotlyChart: React.FC<DynamicPlotlyChartProps> = ({ chartData, width, height }) => {
  const layoutWithSize = {
    ...chartData?.layout,
    width: parseInt(width.toString(), 10), // Ensure width/height are strings for parseInt
    height: parseInt(height.toString(), 10), // Ensure width/height are strings for parseInt
  };

  return <Plot data={chartData?.data || []} layout={layoutWithSize} config={{ responsive: true }} />;
};

export default DynamicPlotlyChart;
